import { FormBaseTableComponent } from '../form-base-table/form-base-table.component';
import { Component } from '@angular/core';
import { rvdKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-form-rvd-table',
    templateUrl: './form-rvd-table.component.html',
    styleUrls: ['../form-base-table/form-base-table.scss'],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
        Tooltip,
        TranslatePipe,
    ],
})
export class FormRvdTableComponent extends FormBaseTableComponent {

    constructor() {
        super();
        this.generateColumns(rvdKeys);
    }
}
